const cMenuMoreInit = () => {

  const menuMoreButtons = document.querySelectorAll('.js-menu-more-btn')

  menuMoreButtons.forEach(menuMoreButton => {
    menuMoreButton.addEventListener('click', function (e) {
      document.documentElement.classList.toggle('c-menu-more-is-open')
    })
  })
}

export default cMenuMoreInit
